import { Pipe, PipeTransform } from '@angular/core';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'transactionStatusDisplay',
})
export class TransactionStatusDisplayPipe implements PipeTransform {
  transform(value: string): string {
    return transactionStatusDisplayTransform(value);
  }
}

export function transactionStatusDisplayTransform(value: string) {
  return CoreNiceLabelUtils.transactionStatus(value);
}
